import alert from './alert'
import date from './date'

export default {
    install(Vue) {
        Vue.mixin(alert)
        Vue.mixin(date)
    }
}
